import { BzitResponse, BzitVehicleDetails, Result } from '../../bzit';
import { SEARCH_URL } from '../../configs/env';
import { fetchJson } from '../../utils/fetch';

export interface GetVehicleDetailsArgs {
  vehicleId: string;
  currency?: string;
}

export const getVehicleDetails = async ({
  vehicleId,
  currency = 'EUR'
}: GetVehicleDetailsArgs): Promise<Result<BzitVehicleDetails, unknown>> => {
  try {
    const result = await fetchJson<
      BzitResponse<{
        vehicle?: BzitVehicleDetails;
      }>
    >(`${SEARCH_URL}vehicle/${vehicleId}/${currency}`);
    if (result.resultCode === 0 && result.vehicle) {
      return { success: true, result: result.vehicle };
    }
    throw new Error(result.resultMsg);
  } catch (error) {
    return { success: false, error };
  }
};
